import React from "react";
import { Link } from "react-router-dom";

const SingleCategory = ({tutorial}) => {
    const {image_url,details,title,author,total_view,_id}=tutorial;
  return (
    <div>
      <div className="max-w-xs rounded-md shadow-md dark:bg-gray-900 dark:text-gray-100">
        <img
          src={image_url}
          alt=""
          className="object-cover object-center w-full rounded-t-md h-72 dark:bg-gray-500"
        />
        <div className="flex flex-col p-6 space-y-8">
          <div className="space-y-2">
            <h2 className="text-2xl font-semibold tracking-wide">
              {title}
            </h2>
            <p className="dark:text-gray-100 justify">
              {details.slice(0,200)+'....'}<Link to={`/tutorials/${_id}`}  className="text-blue-500 underline">Details</Link>
            </p>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default SingleCategory;
